import Input from '../input';
import {getRestProps} from '../utils';
import Icon from '../icon';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    editing, value, validate,
    disabled, style, tip,
    children, invalid, className
} = self.get();

const classNameObj = {
    'k-editable': true,
    'k-editing': editing,
    'k-disabled': disabled,
    'k-invalid': invalid,
    [className]: className,
};

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this)
    }, [
        function() {try {return (!disabled && !editing )} catch(e) {_e(e)}}.call($this) ?
            h(Icon, {
                'className': 'k-icon-edit k-edit',
                'title': function() {try {return (tip )} catch(e) {_e(e)}}.call($this),
                '_context': $this,
                'ev-click': function() {try {return (self._edit )} catch(e) {_e(e)}}.call($this)
            }) :
            undefined,
        h('div', null, function() {try {return (!editing ? children :
            h(Input, {
            'size': 'small',
            'defaultValue': function() {try {return (value )} catch(e) {_e(e)}}.call($this),
            'ref': function(i) {widgets['input'] = i},
            '_context': $this,
            'ev-blur': function() {try {return (self._onBlur )} catch(e) {_e(e)}}.call($this),
            'ev-keydown': function() {try {return (self._onKeydown )} catch(e) {_e(e)}}.call($this)
        })
        )} catch(e) {_e(e)}}.call($this), 'c-ellipsis')
    ], _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}